import React, { useState, useEffect, useRef } from "react";
import customAxios from "../../libs/axios";
import axios from "axios";
import { Formik, Form } from "formik";
import TextField from "@mui/material/TextField";
// import InputFeild from "../../components/common/NewTextFeild";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";
import "../Assesment/assesment.css";
import { Button } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import PumpsetChart from "../Chart/PumpsetChart";
import { useScreenshot } from "use-react-screenshot";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import storage from "../../firebase/firebase";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const labels = ["Reliable", "Unreliable"];

export default function SprinklerReliability({
  handlePreviousPage,
  previouscallingBackend,
  setPreviousCallingBackend,
  handleNextPage,
  callingBackend,
  setCallingBackend,
  formData,
}) {
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });
  const { state } = useLocation();
  const [arr, setArr] = useState([]);
  const [hydrantarr, setHydrantArr] = useState(false);
  const [text, setText] = useState(true);

  const [comment, setComment] = useState("");
  const ref2 = useRef(null);
  // eslint-disable-next-line
  const [image2, takeScreenshot2] = useScreenshot({
    type: "image2/jpg",
    quality: 1.0,
  });
  const toolbarOptions = [
    ["bold", "italic", "underline"],
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }],
  ];
  const module = {
    toolbar: toolbarOptions,
  };
  const changeFormData = (value, name, id) => {
    const objIndex = arr.findIndex((obj) => obj.id === id);
    arr[objIndex][name] = value;
    setArr([...arr]);
  };

  const downloadImage2 = () => {
    if (!ref2.current) return;
    setCallingBackend(true);
    ref2.current.scrollIntoView({ block: "nearest", inline: "nearest" });
    const captureWidth = ref2.current.offsetWidth;
    const captureHeight = ref2.current.offsetHeight;
    takeScreenshot2(ref2.current, {
      width: captureWidth,
      height: captureHeight,
      scale: 2,
      backgroundColor: "#ffffff",
      scrollX: 0,
      scrollY: -window.scrollY,
    })
      .then((image) => {
        handleImageAsFile2(image);
      })
      .catch((error) => {
        console.error(error);
        setCallingBackend(false);
      });
  };

  const handleImageAsFile2 = async (image) => {
    console.log("image", image);
    try {
      setCallingBackend(true);
      // Convert image URL to Blob
      const response = await axios.get(image, { responseType: "blob" });
      const blob = response.data;

      // Create a unique filename
      const fileName = `image_${new Date().getTime()}.jpg`;

      // Create a reference to the file in Firebase Storage
      const storageRef = ref(storage, `/files/${fileName}`);

      // Upload the Blob
      const uploadTask = uploadBytesResumable(storageRef, blob);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log("percent", percent); // Optional: You can use this to show upload progress
        },
        (err) => console.log("err>>>>>>>>>>>", err),
        () => {
          // Get download URL
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            // Call submit after the image URL is set
            submit(url);
          });
        }
      );
    } catch (error) {
      console.error(error);
    } finally {
      setCallingBackend(false);
    }
  };

  const submit = async (imageUrl) => {
    try {
      await customAxios.put(`/assesment/sprinkler_reliability/${state.id}`, {
        sprinkler: arr,
        sprinklerimage: imageUrl,
        comment: comment,
      });
      setAlert({
        showAlert: true,
        severity: "success",
        message: "Water supply created successfully!",
      });
      setTimeout(
        () =>
          setAlert({
            showAlert: false,
            severity: "success",
            message: "Water supply created successfully!",
          }),
        handleNextPage(),
        5000
      );
    } catch (error) {
      if (error.response.data === "Water supply already exists") {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Water supply already exists!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Water supply already exists!",
            }),
          5000
        );
      } else if (error.response.status === 401) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Unauthorized Access!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Unauthorized Access!",
            }),
          5000
        );
      } else if (error.response.status === 500) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Server Error!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Server Error!",
            }),
          5000
        );
      } else {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Water supply already exists!",
        });
        setTimeout(
          () =>
            setAlert({
              showAlert: false,
              severity: "success",
              message: "Water supply already exists!",
            }),
          5000
        );
      }
    }
  };

  const get = async () => {
    try {
      const { data } = await customAxios.get(`/assesment/${state.id}`);
      const item = [...data.sprinklers.protection].map((item, index) => {
        const wsPlace = data?.water_supply?.place?.[index];
        const reliability = data?.sprinkler_system_reliability?.sprinkler?.[index];
        return {
          id: item?.id,
          sprinkler_system:
            reliability?.sprinkler_system ||
            wsPlace?.sprinkler_system ||
            item?.area_protection,
          reliability: reliability?.reliability || item?.reliability || "",
          demand_flow: wsPlace?.demand_flow ?? item?.demand_flow ?? "",
          demand_pressure:
            wsPlace?.demand_pressure ?? item?.demand_pressure ?? "",
        };
      });
      setArr([...item]);
      setComment(data?.sprinkler_system_reliability?.comment);
    } catch (error) {}
  };

  const handleClick = () => {
    setPreviousCallingBackend(true);
    handlePreviousPage();
  };

  useEffect(() => {
    get();
    setHydrantArr(formData?.hydrant_system_reliability?.hydrant.length);
    // eslint-disable-next-line
  }, [formData]);

  return (
    <div>
      <Formik enableReinitialize>
        {({ dirty, isValid }) => {
          return (
            <Form>
              <Grid
                container
                xs={12}
                sx={{
                  padding: "1rem",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <Grid item xs={12}>
                  <p className="formName">Sprinkler System Reliability</p>
                </Grid>
                <Grid item xs={12}>
                  <Grid container item xs={12}>
                    <FormControlLabel
                      value="start"
                      control={
                        <Switch
                          checked={text}
                          onChange={(e) => {
                            console.log("sfdsgsadf", e.target.checked);
                            setText(e.target.checked);
                          }}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                      label="Display Labels"
                      labelPlacement="start"
                    />
                  </Grid>
                  <div
                    style={{
                      width: "100%",
                      overflowX: "auto",
                      overflowY: "visible",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <PumpsetChart
                      ref={ref2}
                      text={text}
                      installations={arr}
                    />
                  </div>
                </Grid>
                <Grid container spacing={1} item xs={12} pt={"2rem"}>
                  <Grid container item xs={12} spacing={1}>
                    <Grid container item xs={3} spacing={1}>
                      <Grid item xs={12}>
                        <p className="inputTextH">Sprinkler System</p>
                      </Grid>
                    </Grid>
                    <Grid container item xs={9} spacing={1}>
                      <Grid item xs={12}>
                        <p className="inputTextH">Reliability</p>
                      </Grid>
                    </Grid>
                    {arr.map((item, i) => {
                      return (
                        <>
                          <Grid container item xs={3} spacing={1}>
                            <Grid item xs={12}>
                              <p className="inputTextP">
                                {item.sprinkler_system}
                              </p>
                            </Grid>
                          </Grid>
                          <Grid container item xs={9} spacing={1}>
                            <Grid item xs={12}>
                              <Autocomplete
                                hiddenLabel
                                id="reliability"
                                name="reliability"
                                size="small"
                                value={item.reliability}
                                options={labels}
                                getOptionLabel={(option) => option}
                                onChange={(event, newValue) => {
                                  changeFormData(
                                    newValue,
                                    "reliability",
                                    item.id
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField size="small" {...params} />
                                )}
                              />
                            </Grid>
                          </Grid>
                        </>
                      );
                    })}
                    <Grid item xs={12} sx={{ marginTop: "1.5rem" }}>
                      <p className="inputTextP">Comment</p>
                    </Grid>
                    <Grid item xs={12} sx={{ marginBottom: "50px" }}>
                      <ReactQuill
                        modules={module}
                        theme="snow"
                        value={comment || ""}
                        style={{
                          marginBottom: "25px",
                          height: "150px",
                        }}
                        onChange={setComment}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sx={{
                    alignContent: "center",
                    justifyContent: "space-between",
                    marginTop: "5rem",
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() => handleClick()}
                    sx={{
                      backgroundColor: "#22345B",
                      textTransform: "capitalize",
                      fontFamily: "serif",
                      borderRadius: "8px",
                      ":hover": { backgroundColor: "#22345B" },
                    }}
                    disabled={previouscallingBackend}
                  >
                    {previouscallingBackend ? (
                      <CircularProgress
                        size={25}
                        sx={{ color: "#22345B", margin: "0 5px" }}
                      />
                    ) : (
                      "Previous"
                    )}
                  </Button>
                  {!formData?.assessment?.hysrant_water_supply_exclude ? (
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#22345B",
                        textTransform: "capitalize",
                        fontFamily: "serif",
                        borderRadius: "8px",
                        ":hover": { backgroundColor: "#22345B" },
                      }}
                      onClick={() => downloadImage2()}
                      disabled={
                        !arr.every(
                          (item) =>
                            !Object.entries(item).some(
                              ([key, value]) => value === ""
                            )
                        ) ||
                        !hydrantarr ||
                        callingBackend
                      }
                    >
                      {callingBackend ? (
                        <CircularProgress
                          size={25}
                          sx={{ color: "#22345B", margin: "0 5px" }}
                        />
                      ) : (
                        "Save"
                      )}
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#22345B",
                        textTransform: "capitalize",
                        fontFamily: "serif",
                        borderRadius: "8px",
                        ":hover": { backgroundColor: "#22345B" },
                      }}
                      onClick={() => downloadImage2()}
                      disabled={
                        !arr.every(
                          (item) =>
                            !Object.entries(item).some(
                              ([key, value]) => value === ""
                            )
                        ) || callingBackend
                      }
                    >
                      {callingBackend ? (
                        <CircularProgress
                          size={25}
                          sx={{ color: "#22345B", margin: "0 5px" }}
                        />
                      ) : (
                        "Save"
                      )}
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}
